import { requestSuccessFailure, openClosed } from 'utilities/constants';

const authConstants = {
    ...requestSuccessFailure(
        'INITIALISE',
        'SEND_CODE',
        'CONTINUE',
        'REFRESH',
        'SIGN_OUT',
        'LOGGED_IN'),
    ...openClosed(
        'AUTH_CODE_DIALOG',
        'QR_CODE_DIALOG',
        'QR_SCANNER_DIALOG'
    )
};

export default authConstants;